import { useContext, useEffect, useState } from "react";
import JobAnalysisPage0 from "./JobAnalysisPage0";
import JobAnalysisPage1 from "./JobAnalysisPage1";
import JobAnalysisPage2 from "./JobAnalysisPage2";
import JobAnalysisPage3 from "./JobAnalysisPage3";
import JobAnalysisPage4 from "./JobAnalysisPage4";
import JobAnalysisPage5 from "./JobAnalysisPage5";
import JobAnalysisPage6 from "./JobAnalysisPage6";
import JobAnalysisPageFinish from "./JobAnalysisPageFinish";
import usePersistantState from "src/hooks/usePersistantState";
import JobAnalysisPageLogin from "./JobAnalysisPageLogin";
import { getCookie } from "src/services/cookies";
import JobAnalysisPageHelp from "./JobAnalysisPageHelp";
import JobAnalysisPage5plus from "./JobAnalysisPage5plus";
// import JobAnalysisPage7 from "./JobAnalysisPage7";
import { useLocation, useNavigate } from "react-router-dom";
import { get, post } from "src/services/HttpClient";
import userContext from "src/context/userContext";
import jobContext from "src/context/jobContext";
import { getAllLocalStorageData } from "src/utils/getAllLocalStorageData";
import { submitJobData } from "src/utils/submitJobData";
import Loading from "src/components/Loading";

export default function JobAnalysisPage() {
  const [step, setStep] = usePersistantState("step", -1);
  const [jobReload, setJobReload] = useState(0)
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const token = params.get("t");
  const stepParam = params.get("step")

  /***START comment this part */
  if (!jobId) {
    localStorage.clear();
  }
  if (!token) {
    window.location.href =
      process.env.REACT_APP_DASHBOARD_LOGIN_URL + "user/login/";
  }

  const { setUser } = useContext(userContext);
  const { job, setJob } = useContext(jobContext);
  const [isLoading, setIsLoading] = useState(true)


  const getData = async () => {
    setIsLoading(true)
    // getUser
    const result2 = await get("/user", { headers: { Authorization: token } });
    if (result2.success) {
      setUser(result2.body);
    }

    // getJob
    const result = await get(`/jobs/${jobId}`, {
      headers: { Authorization: token },
    });
    if (result.success) {

      setJob(result.body);
      setJobReload(1)
    }

    if (result.success && result2.success) {
      setIsLoading(false)
    }
  }

  const initialData = () => {
    localStorage.setItem("access_token", token);
    if (job?.data) {
      let data = localStorage.getItem("data") ? JSON.parse(localStorage.getItem("data")) : {}
      let jobsData = {}
      const jobData = JSON.parse(job.data);
      Object.entries(jobData).forEach(([key, value]) => {
        jobsData[key] = value
      });
      data[jobId] = jobsData
      localStorage.setItem("data", JSON.stringify(data));
    }
    if (stepParam == "start") {
      setStep(-1)
    } else if (stepParam == "finish") {
      setStep(8)
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    initialData();
  }, [job]);

  /***END comment this part */


  useEffect(() => {

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [step]);

  const handleStep = (selectedStep) => {
    submitJobData(jobId, step)
    if (selectedStep || selectedStep === 0) {
      setStep(selectedStep);
    } else {
      setStep(+step + 1);
    }
  };
  const handleStepDown = () => {
    submitJobData(jobId, step)
    setStep(+step - 1);
  };

  return (
    <>
      {
        isLoading
        &&
        <Loading title="در حال بارگیری اطلاعات" />
      }
      {/* {step === -2 ? <JobAnalysisPageLogin handleStep={handleStep} handleStepDown={handleStepDown} /> : null} */}
      {step === -1 ? (
        <JobAnalysisPageHelp
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 0 ? (
        <JobAnalysisPage0
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 1 ? (
        <JobAnalysisPage1
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 2 ? (
        <JobAnalysisPage2
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 3 ? (
        <JobAnalysisPage3
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 4 ? (
        <JobAnalysisPage4
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 5 ? (
        <JobAnalysisPage5plus
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 6 ? (
        <JobAnalysisPage5
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 7 ? (
        <JobAnalysisPage6
          handleStep={handleStep}
          handleStepDown={handleStepDown}
        />
      ) : null}
      {step === 8 ? (
        <JobAnalysisPageFinish
          handleStep={handleStep}
          handleStepDown={handleStepDown}
          jobReload={jobReload}
        />
      ) : null}
    </>
  );
}
